import { useEffect } from 'react'

import { useAppDispatch } from '@/redux/rootReducer'
import { getConsultation, joinConsultationSocketEvent, leaveConsultationSocketEvent } from '@/redux/reducers/consultation.reducer'

type UseConsultationLifecycleParams = {
  consultationId?: string
}

export function useConsultationLifecycle({ consultationId }: UseConsultationLifecycleParams) {
  const dispatch = useAppDispatch()

  // Fetch consultation and manage socket events
  useEffect(() => {
    if (consultationId) {
      dispatch(getConsultation(consultationId))
      dispatch(joinConsultationSocketEvent(consultationId))

      return () => {
        dispatch(leaveConsultationSocketEvent(consultationId))
      }
    }
  }, [dispatch, consultationId])
}
